import { defineMessages } from 'react-intl';

const MESSAGES = defineMessages({
    yes: {
        id: 'iaso.label.yes',
        defaultMessage: 'Yes',
    },
    no: {
        id: 'iaso.label.no',
        defaultMessage: 'No',
    },
    delete: {
        id: 'iaso.label.delete',
        defaultMessage: 'Delete',
    },
    fullscreen: {
        id: 'iaso.label.fullscreen',
        defaultMessage: 'Fullscreen (scroll to zoom)',
    },
    exitFullscreen: {
        id: 'iaso.label.exitFullscreen',
        defaultMessage: 'Exit fullscreen',
    },
    zoomIn: {
        id: 'iaso.label.zoomIn',
        defaultMessage: 'Zoom in',
    },
    zoomOut: {
        id: 'iaso.label.zoomOut',
        defaultMessage: 'Zoom out',
    },
});

export default MESSAGES;
